import React from "react";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Carousel } from "antd";
import   'animate.css';

import styles from "./CitySliderComponent.module.css";

export default function CitySliderComponent(props) {
  const { sliderDetail: sliderImages } = props;
  const handleImageClick = (url) => {
    if(url) window.open(url, '_blank'); // Open URL in a new tab
  };
  return (
    <div className={`w-100 ${styles.city_slider_wrapper}`}>
      {Array.isArray(sliderImages) ? (
        <>
        <div className={styles.city_slider_bg} style={ props.venueURL ? { cursor: 'pointer' } : {}} onClick={() => handleImageClick(props.venueURL)}></div>
          <Carousel
            autoplay={true}
            autoplaySpeed={8000}
            arrows
            prevArrow={<LeftOutlined />}
            nextArrow={<RightOutlined />}
          >
            {sliderImages.map((image) => (
              <div key={image._id}>
                
                <img
                  src={process.env.IMAGE_LINK + image.path}
                  className={styles.sliderImage}
                  alt=""
                  width={1366}
                  height={625}
                />
               
                <div className={styles.sliderImageText}>
                  <div className={styles.sliderImageTitle}>{image.title} </div>
                  <div className={styles.sliderImageDescribtion}>
                    {image.description}
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
          <div className={styles.city_slider_top}>
            <a className={styles.scroll_down} href="#bandPerformed">
            <div className='animate__animated
                          animate__fadeInDown
                          animate__delay-2s
                          animate__duration-1.2s'
            >
                <div className={styles.scroll_down_object}>
                  {" "}
                  <span></span>{" "}
                </div>
              </div>
              <div className='animate__animated
                          animate__fadeInUp
                          animate__delay-2.2s
                          animate__duration-1.2s'
              >
                <h6 className={styles.city_scroll_down_title}>Scroll Down</h6>
              </div>
              <div className='animate__animated
                          animate__fadeInUp
                          animate__delay-2.4s
                          animate__duration-1.2s'
              >
                <p className={styles.city_scroll_down_text}>to discover more</p>
              </div>
            </a>
          </div>
        </>
      ) : (
        <div style={{ height: "110px" }}></div>
      )}
    </div>
  );
}
